import { IconSVG } from '../types';

export const AlarmOnRounded = ({ size, style }: IconSVG) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      style={style}
      fill="none" 
      viewBox="0 0 74 74">
      <path
        fill="currentColor"
        d="m33.8 42.181-4.343-4.343q-.914-.915-2.133-.914-1.22 0-2.134.914-.914.915-.914 2.172t.914 2.171l6.476 6.553q.915.914 2.134.914 1.22 0 2.133-.915l12.953-12.952q.914-.914.914-2.171t-.914-2.172-2.172-.914-2.171.914zM37 67.476q-5.715 0-10.705-2.171-4.99-2.172-8.686-5.867t-5.866-8.686Q9.57 45.762 9.57 40.049t2.172-10.705 5.866-8.686 8.686-5.866T37 12.619t10.705 2.172 8.685 5.866 5.867 8.686 2.171 10.705-2.171 10.704q-2.172 4.992-5.867 8.686-3.694 3.696-8.685 5.867T37 67.476m-30.324-44.8q-.838-.838-.838-2.133t.838-2.133l8.686-8.686q.838-.838 2.133-.838t2.133.838.838 2.133-.838 2.134l-8.685 8.685q-.839.839-2.134.838-1.295 0-2.133-.838m60.648 0q-.839.839-2.134.838-1.294 0-2.133-.838l-8.686-8.685q-.838-.839-.838-2.134t.838-2.133q.838-.838 2.134-.838 1.294 0 2.133.838l8.686 8.686q.838.838.838 2.133 0 1.296-.838 2.133M37 61.381q8.914 0 15.124-6.21t6.21-15.123-6.21-15.124T37 18.714t-15.124 6.21-6.21 15.124 6.21 15.124T37 61.382"
       />
    </svg>
  );
};
